module.exports = __webpack_public_path__ + "img/xwgj.b6a66af2.png";